import React from "react"
import Head from "next/head"
import { Default, MetaProps, MetaType, OG } from "."

// TWITTER Open Graph definitions

export const OGTwitter = (props: MetaProps) => {
  const { featuredImage, title, twitterCard, description, featuredVideo } = props
  const pageTitle = !title ? Default.Tagline : title
  const card = !twitterCard ? MetaType.TwitterCardSummary : twitterCard
  const text = description ? description.replace(/[\r\n]/gm, " ") : Default.Description

  // -----------------------------
  // Twitter Opengraph tags — https://developer.twitter.com/en/docs/twitter-for-websites/cards/guides/getting-started

  const twitterOpengraph = []

  twitterOpengraph.push(
    // twitter:card
    { key: OG.TwitterCard, property: OG.TwitterCard, content: card },
    // twitter:site
    { key: OG.TwitterSite, property: OG.TwitterSite, content: MetaType.TwitterSite },
    // twitter:title
    { key: OG.TwitterTitle, property: OG.TwitterTitle, content: pageTitle },
    // twitter:description
    { key: OG.TwitterDescription, property: OG.TwitterDescription, content: text },
  )

  // twitter:player (video URL)
  if (featuredVideo && twitterCard == MetaType.TwitterCardPlayer) {
    twitterOpengraph.push(
      { key: OG.TwitterPlayer, property: OG.TwitterPlayer, content: featuredVideo.url },
      { key: OG.TwitterPlayerHeight, property: OG.TwitterPlayerHeight, content: "1280" },
      { key: OG.TwitterPlayerWidth, property: OG.TwitterPlayerWidth, content: "1280" },
    )
  }

  // twitter:image
  if (featuredImage) {
    twitterOpengraph.push(
      { key: OG.TwitterImage, property: OG.TwitterImage, content: featuredImage.imgurl },
      { key: OG.TwitterImageAlt, property: OG.TwitterImageAlt, content: featuredImage.imgalt },
    )
  } else {
    twitterOpengraph.push(
      { key: OG.TwitterImage, property: OG.TwitterImage, content: Default.FeaturedImage },
      { key: OG.TwitterImageAlt, property: OG.TwitterImageAlt, content: Default.FeaturedImageAlt },
    )
  }

  // NOTE: Open Graph protocol specifies the use of 'property' and 'content' attributes for markup (<meta property="og:image" content="http://example.com/ogp.jpg"/>) while Twitter cards use 'name' and 'content'. Twitter’s parser will fall back to using property and content,...
  // https://developer.twitter.com/en/docs/twitter-for-websites/cards/guides/getting-started
  const allTags = twitterOpengraph.map((item) => (
    <meta data-testid={item.key} key={item.key} name={item.property} content={item.content} />
  ))

  return <Head>{allTags}</Head>
}
